
export const EstimatedUnbillFigureConstant = {
    Table: {
        YEAR: "Year",
        MONTH: "Month",
        AMOUNT: "Amount",
    },
    Title: {
        CATEGORY: "Reports",
        TITLE: "Estimated Unbill Figure",
    },
}
